import React from "react";

type KitchenStoveIconProps = {
  colour?: string;
  fillColor?: string;
  width?: number;
  height?: number;
};

export const KitchenBurnerIcon: React.FC<KitchenStoveIconProps> = ({
  colour = "black",
  fillColor = "none",
  width,
  height,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Kitchen Stove Icon</title>

      {/* Outer frame of the stove */}
      <rect
        x="5"
        y="5"
        width="90"
        height="90"
        fill={fillColor}
        stroke={colour}
        strokeWidth="2"
      />

      {/* Burners */}
      <circle
        cx="25"
        cy="25"
        r="12"
        fill={fillColor}
        stroke={colour}
        strokeWidth="2"
      />
      <circle
        cx="75"
        cy="25"
        r="12"
        fill={fillColor}
        stroke={colour}
        strokeWidth="2"
      />
      <circle
        cx="25"
        cy="75"
        r="12"
        fill={fillColor}
        stroke={colour}
        strokeWidth="2"
      />
      <circle
        cx="75"
        cy="75"
        r="12"
        fill={fillColor}
        stroke={colour}
        strokeWidth="2"
      />

      {/* Inner ignition points */}
      <circle cx="25" cy="25" r="5" fill={colour} />
      <circle cx="75" cy="25" r="5" fill={colour} />
      <circle cx="25" cy="75" r="5" fill={colour} />
      <circle cx="75" cy="75" r="5" fill={colour} />

      {/* Control knobs */}
      <circle cx="20" cy="95" r="5" fill={colour} />
      <circle cx="40" cy="95" r="5" fill={colour} />
      <circle cx="60" cy="95" r="5" fill={colour} />
      <circle cx="80" cy="95" r="5" fill={colour} />
    </svg>
  );
};
